import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BannerImg from "../../../images/locationgcc/custom-software/robust.webp";

function Banner(props) {
  return (
    <div
      className="revolution_gcc p-100"
      style={{
        backgroundImage: `url(${BannerImg})`,
        backgroundPosition: "left",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={12} xl={6} xxl={6} className="ms-auto">
            <h2>Building Robust Software Solutions For Businesses of Future</h2>
            <p>
              Our software company in Dubai boards the right in-house talent and
              expertise to serve businesses of all sizes and scopes and create
              and deliver the best solutions. Companies get to work with
              customer-centric teams that are well-informed and equipped to
              build the robust digital solution they need—with all the features
              and functionalities.
            </p>
            <p>
              Having worked with more than 500+ businesses over the past few
              years, including Fortune 500 companies, gives our software
              development company Dubai team the confidence to take on more
              considerable challenges and continue our legacy to build powerful
              technology solutions and a better world. All our software
              development company UAE workforce—software engineers, designers,
              digital marketers, ASO experts, and strategists give us an edge
              that we leverage to build the best possible solution and deliver a
              quality experience to our clients and their customer base.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              {" "}
              Let's Take Your Brand Online
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
